module.exports = __webpack_public_path__ + "static/media/person.472743f5.svg";